import { render, staticRenderFns } from "./FormCat.vue?vue&type=template&id=08046a6e"
import script from "./FormCat.vue?vue&type=script&lang=js"
export * from "./FormCat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports